import LogoCard from './logo';
import ReasonCard from './reason';
import ReferenceCard from './reference';
const SpecialCard = {};
SpecialCard.Logo = LogoCard;
SpecialCard.Reason = ReasonCard;
SpecialCard.Reference = ReferenceCard;
export default SpecialCard;
//# sourceMappingURL=index.js.map